import amplitude from "amplitude-js";
import environment from "../environment";

// docs: https://developers.amplitude.com/

let disableAnalytics = environment.name === "localhost";

export const initAnalytics = (appVersion) => {
  if (disableAnalytics) return; // disable analytics on localhost

  amplitude.getInstance().init(environment.aplitudeAPIkey);
  amplitude.getInstance().setVersionName(appVersion);
};

export const logOutUserAnalytics = () => {
  if (disableAnalytics) return; // disable analytics on localhost

  amplitude.getInstance().setUserId(null);
  //amplitude.getInstance().regenerateDeviceId();
};

export const logInUserAnalytics = (
  email,
  name,
  userId,
  euroUserId,
  appVersion
) => {
  if (disableAnalytics) return; // disable analytics on localhost

  /* We need to replace the | with _ because the native app is identifying users on Amplitude using this formatting
  and we need to be consistent to avoid duplicating users. More info -> https://mggroup.atlassian.net/browse/PLAT-400*/
  const userIdWithUnderscore = userId.replace("|", "_");

  amplitude.getInstance().setUserId(userIdWithUnderscore);
  amplitude.getInstance().setUserProperties({
    email,
    nombre: name,
    userIdWithUnderscore,
    euroUserId,
    appVersion,
  });
};

export const logEventAnalytics = (eventName, eventData) => {
  if (disableAnalytics) return; // disable analytics on localhost

  amplitude.getInstance().logEvent(eventName, eventData);
};
